import React, { useEffect, useState } from "react";
import Card from "components/card";
import Button from "components/button";
import { getProjects, deleteProject } from "services/projects";
import { useToast } from "components/Toast";
import { useNavigate } from "react-router-dom";
import Pagination from "components/Pagination";

const ProjectsAdmin: React.FC = () => {
  const [projects, setProjects] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const perPage = 10;
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await getProjects();
        setProjects(Array.isArray(data?.data) ? data.data : []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleDelete = async (id: number) => {
    if (!window.confirm("Delete project?")) return;
    try {
      await deleteProject(id);
      setProjects((prev) => prev.filter((p) => p.id !== id));
    } catch (err) {
      console.error(err);
      toast.showError("Failed to delete project");
    }
  };

  const total = projects.length;
  const visible = projects.slice((page - 1) * perPage, page * perPage);

  return (
    <Card extra="w-full p-4">
      <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-2xl font-bold">Projects</h2>
        <div className="mt-3 sm:mt-0">
          <Button as="link" to="/admin/projects/create">
            Create Project
          </Button>
        </div>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : visible.length === 0 ? (
        <p className="text-gray-500">No projects yet.</p>
      ) : (
        <div className="space-y-4">
          {visible.map((p) => (
            <div
              key={p.id}
              className="flex flex-col rounded bg-white p-4 shadow-sm dark:bg-navy-700 md:flex-row md:items-center md:justify-between"
            >
              <div>
                <h3 className="font-semibold">{p.title}</h3>
                <p className="text-sm text-gray-600 dark:text-gray-300">
                  {p.summary}
                </p>
              </div>
              <div className="mt-3 flex items-center space-x-2 md:mt-0">
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => navigate(`/admin/projects/${p.id}/edit`)}
                >
                  Edit
                </Button>
                <Button
                  size="sm"
                  variant="danger"
                  onClick={() => handleDelete(p.id)}
                >
                  Delete
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
      <Pagination
        page={page}
        perPage={perPage}
        total={total}
        onPageChange={setPage}
      />
    </Card>
  );
};

export default ProjectsAdmin;
// (removed duplicate placeholder)
